import List from "./list/MusicProductsPhysical";
import Create from "./create/CreateMusicProductPhysical";
import Edit from "./edit/EditMusicProductPhysical";
import Individual from "./individual/MusicProductPhysical";

export default { List, Create, Edit, Individual };
